import { passCodes } from '../passCodes';

export const step17riddle = {
    id: 17,
    title: 'Vyšetřování',
    taskText: `
        <p>
            Odpovězte správně na všechny otázky a procvičte si mysl.
        </p>
    `,
    cipher: {
        text: `
            <p>
                Kolik zlatých hvězd vidíme od zastávky na kostelu?
            </p>
            <ol type="a">
                <li>1</li>
                <li>2</li>
                <li>3</li>
            </ol>
        `,
        label: 'Úkol',
    },
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[5],
    additionalInfo: 'Odpovědí je písmeno a/b/c',
    points: false,
    hints: [
        {
            text: 'Hvězdy jsou 2',
        },
    ],
};
